import { render, staticRenderFns } from "./FrzAssignementCaliber.vue?vue&type=template&id=f74e65a4"
import script from "./FrzAssignementCaliber.vue?vue&type=script&lang=js"
export * from "./FrzAssignementCaliber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports